<template>
  <div>
    <div class="text-center text-black">
      <span class="text-3xl font-bold">
         <!-- {{title}} -->
      </span>
    </div>

    <div class="text-2xl text-black font-thinn">
      <slot></slot>
    </div>
<!--     <div v-if="primaryButtonVisible" class="flex justify-center mt-8">
      <vs-button icon-pack="feather" icon="icon-check" color="dark" @click="$emit('primaryButtonClick')">{{buttonTitle}}</vs-button>
    </div> -->
  </div>
</template>

<script>

// import _ from 'lodash'


export default {
  props: ['order', 'title', 'buttonTitle', 'primaryButtonVisible'],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {

  }
}

</script>
<style lang="scss">
  .lesson-wizard {
    .wizard-nav{
      display: none !important;
    }
  }

  .lesson-wizard {
    .wizard-btn {
      color: black !important;
      background-color: white !important;
    }
  }
  .lesson-intro-image {
    max-height: 300px
  }
  .lesson-intro-image-wrapper {
    height: 300px
  }
</style>
